import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import Dialog from 'components/Dialog';
import InvoiceEditor from './InvoiceEditor';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
class InvoiceEditorDialog extends Dialog {
    render() {
        const { handleSubmit, submitting, onOk, title, submitButtonLabel, initialValues, isUpdate, editStorno } = this.props;

        return <Modal backdrop="static" enforceFocus={true} show={this.state.show} onHide={this.hide} dialogClassName="invoice-editor-dialog"> 
            <form  onSubmit={handleSubmit(onOk)}>
                <Modal.Header closeButton>
                    {editStorno && <Modal.Title>{initialValues.has_credit_note? `${isUpdate? "Update": "Add"} Credit Note` : `${isUpdate? "Update": "Add"}  Storno`}</Modal.Title>}
                    {!editStorno && <Modal.Title>Update Invoice</Modal.Title>}
                    {!editStorno && <style dangerouslySetInnerHTML={{__html: `
                    .modal-dialog{
                        max-width: 500px;
                        min-width: auto;
                    }
                    .rdt.rdtOpen{
                        position: fixed;
                    }
                    `}}>
                    </style>}
                    {editStorno && <style dangerouslySetInnerHTML={{__html: `
                    .modal-dialog{
                        max-width: 800px;
                        min-width: auto;
                        width: auto;
                    }
                    `}}>
                    </style>}
                </Modal.Header>

                <Modal.Body>
                    <InvoiceEditor {...this.props} />
                </Modal.Body>

                <Modal.Footer>
                    <Button type="button" onClick={this.hide}>Cancel</Button>
                    <Button disabled={submitting} type="submit" bsStyle="success"><i className="fa fa-check"></i>&nbsp;{`${isUpdate? "Save Changes": "Add"}`}</Button>
                </Modal.Footer>
            </form>
        </Modal>
    }
}

let form = reduxForm({ form: "InvoiceEditor", enableReinitialize: true})(InvoiceEditorDialog);
form = connect((state)=>{
    let initialValues = {...state.orders.selectedOrder, ...state.orders.selectedOrder.refund_order};   
    return {
        initialValues: initialValues,
        initialOrder: state.orders.selectedOrder,
        isUpdate: state.orders.selectedOrder.isUpdate,
        editStorno: state.orders.selectedOrder.editStorno,
        editorValues: state.form.InvoiceEditor ? state.form.InvoiceEditor.values: {}
    }
}, null, null, {withRef: true})(form);
export default form;


// WEBPACK FOOTER //
// app/components/dashboard/InvoiceEditorDialog.jsx